<template>
  <div class="ly-flex-center">

    <div style="height: 100%"
      class="d-flex justify-content-center align-items-center">
      <slot />
    </div>

  </div>
</template>

<script>
export default {
  name: 'ly-flex-center',
  components: { }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/comps/flex-center.vue